import { getImageUrlFromName, toTitleCase } from '../../../util'

const HotelTransportLayout = ({ layout, value }) => {
  const icon = require('../../../assets/images/tick.svg').default
  return (
    <div
      style={{
        padding: '16px 20px 8px 20px',
        background: layout.color ? `#${layout.color}` : '',
        // background: '#f000f0',
      }}
    >
      <div
        style={{
          marginTop: '10px',
          marginBottom: '24px',
          textAlign: 'left',
          color: 'var(--gray100)',
          listStyle: 'none',
        }}
      >
        <p className="headline1">{layout.display_name}</p>
      </div>

      {value.map((item) => {
        let iconUrl = getImageUrlFromName(item.icon_name)

        return (
          <div>
            {item.options.map((innerItem) => {
              return (
                <div
                  style={{
                    display: 'flex',
                    marginBottom: '24px',
                    alignItems: 'flex-start',
                    color: 'var(--gray80)',
                  }}
                >
                  <div>
                    <img
                      src={iconUrl}
                      alt=""
                      style={{
                        marginRight: '14px',
                        width: '1.5rem',
                        height: '1.5rem',
                      }}
                    ></img>
                  </div>
                  <div>
                    <div
                      style={{
                        color: 'var(--gray100)',
                        marginBottom: '8px',
                      }}
                    >
                      <p
                        className="body2"
                        style={{ margin: '0px', lineHeight: '150%' }}
                      >
                        {toTitleCase(innerItem.name)}
                      </p>
                    </div>
                    <div
                      style={{
                        color: 'var(--gray80)',
                        lineHeight: '150%',
                      }}
                    >
                      <p className="body4">{innerItem.dist_text}</p>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        )
      })}

      {/* { value.map((item) => {
        let iconUrl =  getImageUrlFromName(item.icon_name)

          return (
            <div
              style={{
                display: 'flex',
                marginBottom: '-1rem',
                alignItems: 'center',
                color: 'var(--gray80)',
              }}
            >
                <div>
                <img src={iconUrl} alt="" style={{ 
                        marginRight: '14px', 
                        width: '1.5rem', 
                        height:'1.5rem' 
                    }}>
                </img>
                </div>
                <div>
                <div>
                <p className="body2">{item.display_name}</p>
                </div>
                <div>
                <p className="body2">{item.display_name}</p>
                </div>
                </div>
            </div>
          )
        })} */}
    </div>
  )
}

export default HotelTransportLayout
